import axios from "axios";
import { api } from "@/api";
const configHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
};

export default {
  // Заказа готового изделия. Список моделей
  setDraft ({ commit, state }, {type, body}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/drafts/${type}`, body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  getDraft ({ commit}, type) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/drafts/${type}`).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  // Заказа готового изделия. Список моделей
  setModelsZgi ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/zgi/models`).then(res => {
        resolve(res.data);
        commit('updateModelsZgi', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  // Заказа готового изделия. Список материалов
  setMaterialsZgi ({ commit }, {id}) {
    return new Promise((resolve, reject) => {
     axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/zgi/models/${id}/materials`).then(res => {
        resolve(res.data);
        commit('updateMaterialsZgi', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  copyOrder({ commit }, {uuid, path}) {
    return new Promise((resolve, reject) => {
     axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/${uuid}/copy`).then(res => {
        resolve(res.data);
        commit('updateCopyOrder', {
          'path': path,
          'data': res.data,
        });
      }, error => {
       reject(error.response.data.errorMessage)
      })
    })
  },

  loadOrderFromFile ({ commit }, {body, path}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/wholesale-order/${path}/load`, body, configHeaders).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setZgiOptions ({ commit }, {id}) {
    return new Promise((resolve, reject) => {
     axios.get(`${process.env.VUE_APP_API_URL}/api/models/${id}/options`).then(res => {
        resolve(res.data);
        commit('updateOptionsList', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  //Заказа отрезов. Список ситстем
  setModelsCut ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/cut/items-categories`).then(res => {
        resolve(res.data);
        commit('updateModelsCut', res.data);
      }, error => {
        reject(error)
      })
    })
  },
  //Заказа отрезов. Список материалов
  setMaterialsCut ({ commit }, {id = '', query = ''}) {
    return new Promise((resolve, reject) => {
     axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/items?type=cut&category_id=${id}&query=${query}`).then(res => {
        resolve(res.data);
        commit('updateMaterialsCut', res.data);
      }, error => {
        reject(error)
      })
    })
  },
  //Заказа оптовых позиций. Список категорий
  setModelsOpt ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/opt/items-categories`).then(res => {
        resolve(res.data);
        commit('updateModelsOpt', res.data);
      }, error => {
        reject(error)
      })
    })
  },
  //Заказа оптовых позиций. Список товаров
  setMaterialsOpt ({ commit }, {id = '', query = ''}) {
    return new Promise((resolve, reject) => {
     axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/items?type=opt&category_id=${id}&query=${query}`).then(res => {
        resolve(res.data);
        commit('updateMaterialsOpt', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  loadSetOpt ({ commit }, id) {
    return new Promise((resolve, reject) => {
     axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/items?type=opt&set_id=${id}`).then(res => {
        resolve(res.data);
        commit('updateSetList', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  calculateOptionsValues(_, body) {
    return new Promise((resolve, reject) => {
      api.methods.calculate.options.values.post(body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  //Расчет стоимости
  calculateOrder ({ commit }, {body, path}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/wholesale-order/${path}/calculate`, body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  orderSendForm ({ commit }, {body, path}) {
    commit('common/updatePreload', '', {root: true});
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/wholesale-order/${path}/ordering`, body).then(res => {
        resolve(res.data);
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error);
        commit('common/updatePreload', '', {root: true});
      })
    })
  },

  loadConfigCut ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/cut/items-config`).then(res => {
        resolve(res.data);
        commit('updateConfigCut', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  orderEditLoad ({ commit }, {uuid}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/${uuid}/detail-info`).then(res => {
        resolve(res.data);
        commit('orderEditUpdate', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  paymentLoad ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/payment-methods`).then(res => {
        resolve(res.data);
        commit('paymentUpdate', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  orderUpdate ({ commit }, {body, uuid}) {
    commit('common/updatePreload', '', {root: true});
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/wholesale-order/${uuid}/update`, body).then(res => {
        resolve(res.data);
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error);
        commit('common/updatePreload', '', {root: true});
      })
    })
  },
}
